import {Address} from "../../model/Address";
import "./address-validity-info.component.scss"

export class AddressValidityInfoComponent {
    public static instance = {
        template: require("./address-validity-info.component.html"),
        controller: [AddressValidityInfoComponent],
        bindings: {
            address: '='
        }
    };

    constructor() {
    }

    private address: Address;

    getTheme() {
        if (this.address != null && this.address.verification.valid) {
                return 'valid-address-message';
        } else {
                return 'invalid-address-message';
        }
    }
}